import { NewsletterFormDTO } from 'types/newsletter';
import { request } from 'utils/request';

export const submitNewsletterForm = async (newsletterData: NewsletterFormDTO) =>
    await request('/newsletter/create', { method: 'POST' }, newsletterData);
